var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCellular5Bars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 53,
    viewBox: "0 0 71 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.63949 26H2.36052C1.05684 26 0 27.0336 0 28.3087V50.6913C0 51.9664 1.05684 53 2.36052 53H8.63949C9.94316 53 11 51.9664 11 50.6913V28.3087C11 27.0336 9.94316 26 8.63949 26Z",
    fill: "#6AA442"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6395 0H62.3605C61.7345 0 61.1341 0.238731 60.6914 0.663675C60.2487 1.08862 60 1.66496 60 2.26593V50.7341C60 51.335 60.2487 51.9114 60.6914 52.3363C61.1341 52.7613 61.7345 53 62.3605 53H68.6395C69.2655 53 69.8659 52.7613 70.3086 52.3363C70.7513 51.9114 71 51.335 71 50.7341V2.26593C71 1.66496 70.7513 1.08862 70.3086 0.663675C69.8659 0.238731 69.2655 0 68.6395 0Z",
    fill: "#6AA442"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6395 7H47.3605C46.7345 7 46.1341 7.23682 45.6914 7.65835C45.2487 8.07988 45 8.6516 45 9.24774V50.7523C45 51.3484 45.2487 51.9201 45.6914 52.3416C46.1341 52.7632 46.7345 53 47.3605 53H53.6395C54.2655 53 54.8659 52.7632 55.3086 52.3416C55.7513 51.9201 56 51.3484 56 50.7523V9.24774C56 8.6516 55.7513 8.07988 55.3086 7.65835C54.8659 7.23682 54.2655 7 53.6395 7Z",
    fill: "#6AA442"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6395 13H32.3605C31.0568 13 30 14.021 30 15.2805V50.7195C30 51.979 31.0568 53 32.3605 53H38.6395C39.9432 53 41 51.979 41 50.7195V15.2805C41 14.021 39.9432 13 38.6395 13Z",
    fill: "#6AA442"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6395 20H17.3605C16.0568 20 15 21.0106 15 22.2572V50.7428C15 51.9894 16.0568 53 17.3605 53H23.6395C24.9432 53 26 51.9894 26 50.7428V22.2572C26 21.0106 24.9432 20 23.6395 20Z",
    fill: "#6AA442"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellular5Bars);
export default __webpack_public_path__ + "static/media/cellular-5-bars.3db25cb60aab35461b4cbfd2d77605cd.svg";
export { ForwardRef as ReactComponent };